import React, { useState, useEffect } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import "./ReportingTable.scss";
import DynamicTable from "../DynamicTable/DynamicTable";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import {
  ListDetailbyUserJSON,
  deleteFile,
  ViewAllOperators,
  ATMListDetailbyUserJSON,
} from "../../util/API/reporting";
import { CSVLink } from "react-csv";
import { Box, IconButton } from "@mui/material";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import { runPDFService } from "../../util/API/reporting";
import pdfImage from "../../images/pdf-image.svg"
import csvImage from "../../images/excel-image.svg"
import LoadingPage from "../UI/LoadingPage/LoadingPage";
import { useSelector } from "react-redux";
import { decodeHtmlEntities, setAsArray } from "../../util/utilfunctions/utilFunctions";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function ReportingTable({
  handleDetailSwitch,
  reportingDetails,
  getTransactionTypeDetail,
  transactionHistory,
  hasData,
  thisduration,
  showDetails,
  isAdmin,
  startDate, 
  endDate,
  setFullReportingDetails,
  userID,
  transactionType,
  setTransactionType,
  filter,
  setFilter,
  options,
  setCurrency,
  isOperator,
  reportType
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isLoading, setIsLoading] = useState(true);
  const [reportingTable, setReportingTable] = useState(null);
  const [recordNumber, setRecordNumber] = useState("")
  const [alert, setAlert] = useState({
    showAlert: false, 
    severity: '',
    message: '',
    header: ''
  });
  let configVariables = useSelector((state) => state.config.baseConfig);


 const handleViewAll = async () => {
  setIsLoading(true);

  // Early exit if no records to view
  if (!showDetails && recordNumber === "0") {
    setAlert({
      header: 'Error',
      showAlert: true,
      message: "No records found to view",
      severity: 'error'
    });
    setIsLoading(false);
    return;
  }

  let response;

  try {
    if (isOperator === "true") {
      response = await ViewAllOperators(thisduration, startDate, endDate, userID);
    } else {
      // SAFETY: Only proceed if transactionHistory exists and has data
      if (!transactionHistory || !Array.isArray(transactionHistory) || transactionHistory.length === 0) {
        setAlert({
          header: 'No Data',
          showAlert: true,
          message: "No transaction history available to generate detailed report.",
          severity: 'warning'
        });
        setIsLoading(false);
        return;
      }

      const transtypeString = transactionHistory
        .map(record => record?.Vtransrecords?.transtype)
        .filter(Boolean) // remove any undefined/null
        .join(",");

      const currcode = transactionHistory[0]?.Vtransrecords?.currcode || "USD";

      if(reportType == "ATM") {
        response = await ATMListDetailbyUserJSON(
          thisduration,
          transtypeString,
          startDate,
          endDate,
          currcode,
          isAdmin,
          userID,
          filter.user
        )
      } else {
        response = await ListDetailbyUserJSON(
          thisduration,
          transtypeString,
          startDate,
          endDate,
          currcode,
          isAdmin,
          userID,
          filter.user,
          true
        );
      }
    }

    let records = response?.payload?.record;
    records = setAsArray(records); // this already handles null/undefined → []

    setFullReportingDetails(records);
    setTransactionType({
      key: 0,
      value: 0,
      label: "All Transactions"
    });

    if (!showDetails) {
      handleDetailSwitch();
    }

    setFilter(prev => ({ ...prev, viewAll: false }));
  } catch (error) {
    console.error("Error in handleViewAll:", error);
    setAlert({
      header: 'Error',
      showAlert: true,
      message: "Failed to load detailed report. Please try again.",
      severity: 'error'
    });
  } finally {
    setIsLoading(false);
  }
};

  useEffect(() => {
    if (filter.clearFilter) {
      setFilter({...filter, clearFilter: false})
    }
  }, [filter]);

  useEffect(() => {
    if (filter.viewAll) {
      setFullReportingDetails([])
      handleViewAll()
    }
  }, [filter, startDate, endDate]);

  useEffect(() => {
    setPage(0)
  }, [showDetails])

  let agent = JSON.parse(sessionStorage.getItem("user")).payload.body;

  useEffect(() => {
    if (transactionHistory === undefined) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [transactionHistory]);

  const getTable = async () => {
    console.log("reportType=========",reportType);
    try {
      let response;
      if (showDetails || filter.viewAll) {
        if(reportType == "Loans") {
          response = await fetch(`/tables/agentLoanReportDetails.json`);
        } else {
          response = await fetch(`/tables/agentReportDetails.json`);
        }
      } else {
        response =
          isOperator === "true"
            ? await fetch(`/tables/operatorReport.json`)
            : await fetch(`/tables/agentReport.json`);
      }
      const tableData = await response?.json();
      if (tableData) {
        const filteredColumns = tableData.columns?.filter(
          (col) => col.header !== "Ref No" && col.header !== "Description"
          // (col) => col.header !== "Source Account" && col.header !== "Ref No" && col.header !== "Description" && col.header !== "Target Account"
        );
  
        setReportingTable({
          ...tableData,
          columns: filteredColumns, 
        });
  
        setRowsPerPage(tableData?.rowsPerPage); 
      }
      setRowsPerPage(tableData?.rowsPerPage); 
    } catch (error) {
      console.error("Error fetching table structure:", error);
    }
  };

  useEffect(() => {
    getTable();
  }, [showDetails, filter]);
  console.log("showDetails==========",showDetails);

  if (thisduration !== 4) {
    if (hasData === false) {
      return <div>No Records Found</div>;
    }
    if (isLoading) {
      return <LoadingPage />;
    }
  }

  const handleButton = async(transtype, currency) => {
    if (transtype === "82") {
      await getTransactionTypeDetail("82,83,84,86", currency);
    }
    else {
      await getTransactionTypeDetail(transtype, currency);
    }
    setTransactionType(options.type.filter(option => option.key === transtype))
    setCurrency(currency)
    if (!showDetails) {
      handleDetailSwitch()
    }
  }

  let pageCount = null;
  let pageNumbers = null;
  if (transactionHistory) {
    pageCount = Math.ceil(showDetails ? reportingDetails?.length / rowsPerPage : transactionHistory?.length / rowsPerPage);
    pageNumbers = Array.from({ length: pageCount }, (_, index) => index);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

const sourceFields = showDetails && reportingTable?.columns;

// const filteredRecords = showDetails && reportingDetails
//   ? reportingDetails.filter((record) => {
//       const vtrans = record?.Vtransrecords;
//       const transactionByName = vtrans.transactionbyfirstname.toLowerCase() + " " + vtrans.transactionbylastname.toLowerCase();
//       const authUserName = agent.User.firstName.toLowerCase() + " " + agent.User.lastName.toLowerCase();

//       return true;
//       // return transactionByName === authUserName;
//   }).map((record) => {
//       const vtrans = record?.Vtransrecords;
//       let filteredRecord = {};

//       sourceFields?.forEach((source) => {
//         try {
//           if (typeof source.source === 'string' && source.source.startsWith('["') && source.source.endsWith('"]')) {
//             source.source = JSON.parse(source.source);
//           }
//           if (Array.isArray(source.source)) {
//             filteredRecord[source.header] = source.source.map(field => vtrans[field]).join(" ");
//           } else {
//             filteredRecord[source.header] = vtrans[source.source];
//           }
//         } catch (error) {
//           console.error(`Error parsing field: ${source.source}`, error);
//         }
//       });

//       return filteredRecord;
//     })
//   : [];

const filteredRecords = showDetails && reportingDetails
  ? reportingDetails.filter((record) => {
      const vtrans = record?.Vtransrecords;
      const transactionByName = vtrans.transactionbyfirstname.toLowerCase() + " " + vtrans.transactionbylastname.toLowerCase();
      const authUserName = agent.User.firstName.toLowerCase() + " " + agent.User.lastName.toLowerCase();

      return true;
      // return transactionByName === authUserName;
  }).map((record) => {
      const vtrans = record?.Vtransrecords;
      let filteredRecord = {};

      // console.log("sourceFields==========",sourceFields);

      sourceFields?.forEach((source) => {
        try {
          if (typeof source.source === 'string' && source.source.startsWith('["') && source.source.endsWith('"]')) {
            source.source = JSON.parse(source.source);
          }
          if (Array.isArray(source.source)) {
            const values = source.source.map(field => vtrans[field]?.trim()).filter(Boolean);
            if (values.length === source.source.length) {
              // All fields are present and non-empty
              filteredRecord[source.header] = decodeHtmlEntities(values.join(" "));
            } else {
              // Fallback to clerkname
              filteredRecord[source.header] = decodeHtmlEntities(vtrans["clerkname"]) || "";
            }
            // filteredRecord[source.header] = source.source.map(field => vtrans[field]).join(" ");
          } else {
            filteredRecord[source.header] = vtrans[source.source];
          }
        } catch (error) {
          console.error(`Error parsing field: ${source.source}`, error);
        }
      });

      return filteredRecord;
    })
  : [];



// const runPDF = async () => {
//   try {
//     // console.log("transactionType?.label--------------",filter?.user ? (options?.user.find(option => option.value === filter?.user)?.label || "") : options?.user[0]?.label);

//     const response = await runPDFService(
//       startDate,
//       endDate,
//       reportingDetails.length,
//       reportingDetails,
//       isAdmin,
//       agent['User'].firstName,
//       agent['User'].lastName,
//       transactionType?.label,
//       filter?.user ? (options?.user.find(option => option.value === filter?.user)?.label || "") : options?.user[0]?.label,
//       isAdmin === "true" ? "Admin Reports" : isOperator === "true" ? "Operator/Clerk Reports" : "Agent Reports"
//     );

//     if (response && response.download) {
//       const fileURL = `${configVariables.baseURL + configVariables.receiptExtension}/${response.download}`;
//       window.open(fileURL, "_blank");
//       const response2 = await deleteFile(response.download)
//     } else {
//       console.error("No file to download in the response:", response);
//     }
//   } catch (error) {
//     console.error("Error in runPDF:", error);
//   }
// };

const runPDF = () => {
  // console.log("Reporting details----------",reportingDetails);
  // const doc = new jsPDF();
  const doc = new jsPDF({
    orientation: 'landscape', // makes it wider
    unit: 'mm',               // measurement unit
    format: 'a4'              // standard A4 size
  });
  doc.setFontSize(16);

  // Define base Y and line spacing
  let y = 22;
  const lineSpacing = 10;

  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text(
    isAdmin === "true"
      ? `Admin Reports - ${filter?.user ? (options?.user.find(option => option.value === filter?.user)?.label || "") : options?.user[0]?.label}`
      : isOperator === "true"
      ? "Operator/Clerk Reports"
      : "Agent Reports",
    doc.internal.pageSize.getWidth() / 2, // center X
    y,
    { align: "center" }
  );
  y += lineSpacing;
  
  // Second line: Start Date (left) and End Date (right)
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(`Start Date: ${startDate}`, 14, y); // left aligned
  doc.text(`End Date: ${endDate}`, doc.internal.pageSize.getWidth() - 14, y, { align: "right" });
  y += lineSpacing;
  
  // Third line: Currency left aligned
  doc.text("Currency: USD", 14, y);
  y += lineSpacing;

  // const headers = ["Date", "Type", "Source Account", "Destination Account", "Clerk", "Ref No", "Amount", "Fees", "Taxes", "Admin Fee", "Description", "Recipient", "Total Amount"];
  const headers = [
    "Date",
    "Type",
    "Source Account",
    "Destination Account",
    "Clerk",
    "Ref No",
    "Amount",
    "Fees",
    "Taxes",
    "Admin Fee",
    "Description",
    "Recipient",
    "Sender",
    "Total Amount",
  ];
  const body = reportingDetails.map(row => {
    const v = row?.Vtransrecords || {};
    let nametodisplay = "";
    let nametodisplay1 = "";
    let sendername = "";
    let sendername1 = "";

    if (v.transtypelabel === "Purchase") {
      nametodisplay = v.senderFirstName || "";
      nametodisplay1 = `${v.senderFirstName || ""} ${v.senderLastName || ""}`;
    } 
    else if (v.transtype === 11 || v.transtype === 80 || v.transtype === 65) {
      nametodisplay1 = `${v.senderFirstName || ""} ${v.senderLastName || ""}`;
    } 
    else {
      nametodisplay = v.recipientFirstName || "";
      nametodisplay1 = `${v.recipientFirstName || ""} ${v.recipientLastName || ""}`;
      sendername = v.senderFirstName || "";
      sendername1 = `${v.senderFirstName || ""} ${v.senderLastName || ""}`;
    }


    const amount = parseFloat(row?.Vtransrecords?.amount || 0);
    const servicefee = parseFloat(row?.Vtransrecords?.servicefee || 0);
    const adminfee = parseFloat(row?.Vtransrecords?.adminfee || 0);
    const taxes = parseFloat(row?.Vtransrecords?.taxamount || 0);
  
    // PHP logic: round individually, sum, then round again
    const fees = (Number(servicefee.toFixed(2)) + Number(adminfee.toFixed(2))).toFixed(2);
    console.log("row?.Vtransrecords=========",row?.Vtransrecords);
  
    return [
      row?.Vtransrecords?.transactiondate?.split(" ")[0] || "",
      row?.Vtransrecords?.transtypelabel || "",
      row?.Vtransrecords?.sourcepilabel || "",
      row?.Vtransrecords?.targetpilabel || "",
      row?.Vtransrecords?.clerkname || "",
      row?.Vtransrecords?.refno || "",
      amount.toFixed(2), // Amount
      fees,              // Fees (servicefee + adminfee)
      taxes.toFixed(2),  // Taxes
      adminfee.toFixed(2), // Admin Fee
      row?.Vtransrecords?.description || "",
      decodeHtmlEntities(nametodisplay1) || "",
      decodeHtmlEntities(sendername1) || "",
      row?.Vtransrecords?.totalamount, // Total Amount
    ];
  });

  // Compute totals
  const totalTransactions = reportingDetails.length;
  const totalAmount = reportingDetails.reduce((sum, r) => sum + parseFloat(r?.Vtransrecords?.amount || 0), 0);
  const totalFees = reportingDetails.reduce((sum, r) => {
    const servicefee = parseFloat(r?.Vtransrecords?.servicefee || 0);
    const adminfee = parseFloat(r?.Vtransrecords?.adminfee || 0);
    return sum + servicefee + adminfee;
  }, 0);
  const totalTaxes = reportingDetails.reduce((sum, r) => sum + parseFloat(r?.Vtransrecords?.taxamount || 0), 0);
  const totalFinal = reportingDetails.reduce((sum, r) => sum + parseFloat(r?.Vtransrecords?.totalamount || 0), 0);

  // Push totals row at the end of body
  body.push([
    { content: `Total ( ${totalTransactions} Transactions )`, colSpan: 6, styles: { halign: 'right', fontStyle: 'bold' } },
    { content: formatNumber(totalAmount), styles: { fontStyle: 'bold' } },
    { content: formatNumber(totalFees), styles: { fontStyle: 'bold' } },
    { content: formatNumber(totalTaxes), styles: { fontStyle: 'bold' } },
    "", "", "", // for Description, Recipient, etc. adjust as per your headers
    { content: formatNumber(totalFinal), styles: { fontStyle: 'bold' } },
  ]);

  autoTable(doc, {
    head: [headers],
    body,
    startY: y,
    styles: { fontSize: 8, cellPadding: 2, lineWidth: 0.1, color:'black' },
    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: 'bold' },
    // margin: { left: 5, right: 5 },
    bodyStyles: { textColor: [0, 0, 0] },
    // footStyles: { fillColor: [255,255,255], textColor: [0,0,0], fontStyle: 'bold' }
    // columnStyles: {
    //   1: { cellWidth: 20 }, // "Type" (index starts from 0)
    //   2: { cellWidth: 20 }, // "Type" (index starts from 0)
    //   3: { cellWidth: 20 }, // "Type" (index starts from 0)
    //   5: { cellWidth: 15 }, // "Ref No"
    //   10: { cellWidth: 10 }, // "Description"
    // }
  });
  const somenum = Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000;
  doc.save(`file${somenum}.pdf`);
};

const formatNumber = (num) => {
  return parseFloat(num || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

  return (
      <>
        {isLoading ? (
          <LoadingPage />
        ) : (
          <>
            {thisduration !== 4 ? (
              <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                {showDetails && (
                  <Box
                    className="text-end"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "right",
                        marginLeft: "auto",
                      }}
                    >
                      <CSVLink
                        data={filteredRecords}
                        filename={`PAiY-${thisduration}-${new Date().toISOString().slice(0, 10)}.csv`}
                        style={{ textDecoration: "none" }}
                      >
                        <IconButton
                          sx={{
                            width: 40,
                            height: 40,
                            color: "#6c757d",
                            backgroundColor: "transparent",
                            "&:hover": {
                              backgroundColor: "rgba(108, 117, 125, 0.1)",
                            },
                          }}
                        >
                          <img src={csvImage} alt="CSV" loading="lazy" />
                        </IconButton>
                      </CSVLink>
    
                      {/* PDF Button */}
                      <IconButton
                        onClick={runPDF}
                        sx={{
                          width: 40,
                          height: 40,
                          color: "#6c757d",
                          backgroundColor: "transparent",
                          "&:hover": {
                            backgroundColor: "rgba(108, 117, 125, 0.1)",
                          },
                        }}
                      >
                        <img src={pdfImage} alt="PDF" loading="lazy" />
                      </IconButton>
                    </Box>
                  </Box>
                )}
    
                {reportingTable && (
                  <DynamicTable
                    tableData={
                      showDetails
                        ? reportingDetails
                        : recordNumber === "0"
                        ? []
                        : transactionHistory
                    }
                    tableSource={reportingTable}
                    handleButton={handleButton}
                    page={page}
                    date={startDate + " to " + endDate}
                  />
                )}
                <BaseCustomerTable
                  page={page}
                  onPageChange={handleChangePage}
                  pageNumbers={pageNumbers}
                />
              </TableContainer>
            ) : (
              <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                {showDetails && (
                  <Box
                    className="text-end"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "right",
                        marginLeft: "auto",
                      }}
                    >
                      <CSVLink
                        data={filteredRecords}
                        filename={`PAiY-${thisduration}-${new Date().toISOString().slice(0, 10)}.csv`}
                        style={{ textDecoration: "none" }}
                      >
                        <IconButton
                          sx={{
                            width: 40,
                            height: 40,
                            color: "#6c757d",
                            backgroundColor: "transparent",
                            "&:hover": {
                              backgroundColor: "rgba(108, 117, 125, 0.1)",
                            },
                          }}
                        >
                          <img src={csvImage} alt="CSV" loading="lazy" />
                        </IconButton>
                      </CSVLink>
    
                      {/* PDF Button */}
                      <IconButton
                        onClick={runPDF}
                        sx={{
                          width: 40,
                          height: 40,
                          color: "#6c757d",
                          backgroundColor: "transparent",
                          "&:hover": {
                            backgroundColor: "rgba(108, 117, 125, 0.1)",
                          },
                        }}
                      >
                        <img src={pdfImage} alt="PDF" loading="lazy" />
                      </IconButton>
                    </Box>
                  </Box>
                )}
    
                {reportingTable && (
                  <DynamicTable
                    tableData={
                      showDetails
                        ? reportingDetails
                        : recordNumber === "0"
                        ? []
                        : transactionHistory
                    }
                    tableSource={reportingTable}
                    handleButton={handleButton}
                    handleButtonText={"View Details"}
                    page={page}
                    date={startDate + " to " + endDate}
                  />
                )}
                <BaseCustomerTable
                  page={page}
                  onPageChange={handleChangePage}
                  pageNumbers={pageNumbers}
                />
              </TableContainer>
            )}
          </>
        )}
    
        <CustomAlert
          severity={alert.severity}
          show={alert.showAlert}
          header={alert.header}
          message={alert.message}
          onClick={(prevDetails) => setAlert({ ...prevDetails, showAlert: false })}
          autoclose={alert.severity === "error" ? false : true}
        />
      </>
  );
}
